import Loading, { LoadingBall } from '@ingka/loading';

type LoadingIndicatorProps = {
  text?: string;
};

const LoadingIndicator = ({ text = '' }: LoadingIndicatorProps) => {
  return (
    <div role="status" aria-live="polite" aria-label={text || 'Loading'}>
      <Loading text={text}>
        <LoadingBall />
      </Loading>
    </div>
  );
};

export default LoadingIndicator;
